@if (isLoading) {
  <div class="xi-loader-container__inline-overlay xi-loader-container__inline-overlay--blur">
    <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
  </div>
}

<div
  *transloco="let t; read: 'configuration-routes.view.configurations-tab'"
  class="configuration-route-configurations__wrapper"
>
  <h5>{{ t('title') }}</h5>

  <div class="configuration-route-configurations__edit-link">
    @if (canEditRoute) {
      <span (click)="onEditConfigurationDialogOpened()">{{ editLinkText }}</span>
    }
  </div>

  <div class="configuration-route-configurations__form-header">
    {{ selectionCountText }}
  </div>

  <div class="configuration-route-configurations__form-header"></div>

  <div class="configuration-route-configurations__form-body">
    <div>
      @for (entry of includedConfigurations; track entry) {
        <div
          class="configuration-route-configurations__panel"
          [class.configuration-route-configurations__panel-selected]="
            entry.configurations[0].configuration === selectedConfiguration
          "
          (click)="onConfigurationSelected(entry.configurations[0])"
        >
          <div class="configuration-route-configurations__panel-header">
            <div class="configuration-route-configurations__configuration-name">
              <xi-custom-pill
                color="CXIC"
                [text]="entry.configurations[0].pillType"
              ></xi-custom-pill>
              {{ entry.configurations[0].configuration.name }}
            </div>
            <div class="configuration-route-configurations__panel-header-title">
              <div class="configuration-route-configurations__language-tranlation-container">
                <div
                  [matTooltip]="
                    configurationRoute.default_language_id === entry.languageId
                      ? ''
                      : t('set-default-language')
                  "
                  [ngClass]="{
                    'disable-click': configurationRoute.default_language_id === entry.languageId,
                  }"
                >
                  <xi-icon-button
                    [icon]="
                      configurationRoute.default_language_id === entry.languageId
                        ? 'star_filled'
                        : 'star'
                    "
                    [disabled]="isSaving || !canEditRoute"
                    (onClick)="toggleDefaultLanguage(entry.languageId, $event)"
                  ></xi-icon-button>
                </div>
                @if (hasTranslationFeature) {
                  <div [matTooltip]="getMachineTranslationTooltip(entry)">
                    <xi-icon-button
                      [icon]="
                        configurationRoute.translation_target_language_id === entry.languageId
                          ? 'translation_filled'
                          : 'translation'
                      "
                      [disabled]="
                        isSaving || !canEditRoute || !canToggleMachineTranslation || isReadOnly
                      "
                      (onClick)="toggleMachineTranslation(entry.languageId, $event)"
                    ></xi-icon-button>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>

    @if (!includedConfigurations.length) {
      <div class="configuration-route-configurations__form-body--empty">
        <h3>{{ t('no-selection-header') }}</h3>
        <p>{{ t('no-selection-content') }}</p>
        <xi-default-button
          buttonSize="large"
          [text]="t('create')"
          (onClick)="onEditConfigurationDialogOpened()"
        ></xi-default-button>
      </div>
    }
  </div>

  @if (selectedConfiguration) {
    <div
      class="configuration-route-configurations__form-body configuration-route-configurations__form-body--config"
    >
      <div
        class="configuration-route-configurations__form-section configuration-route-configurations__form-section--name"
      >
        <xi-custom-pill color="CXIC" [text]="selectedConfigurationType"></xi-custom-pill>
        {{ selectedConfiguration.name }}
      </div>
      <app-configuration-analytic-items-summary
        [selectedConfiguration]="selectedConfiguration"
        [accountLimits]="accountLimits"
        [selectedConfigurationType]="selectedConfigurationType"
      ></app-configuration-analytic-items-summary>
      <div
        class="configuration-route-configurations__form-section configuration-route-configurations__form-section--notes"
      >
        <span>{{ t('notes') }}</span>
        <p>{{ selectedConfiguration.notes }}</p>
      </div>
      <app-tag-editor
        [editable]="false"
        [removable]="false"
        [configuration]="selectedConfiguration"
      ></app-tag-editor>
      <app-configuration-overview
        [configuration]="selectedConfiguration"
        [(templateConfiguration)]="templateConfiguration"
        [industryPacks]="industryPacks"
        [languageTemplates]="languageTemplates"
      ></app-configuration-overview>
    </div>
  }
</div>

@if (showAnalyticItemDialog) {
  <app-lex-xi-modal
    [isVisible]="showAnalyticItemDialog"
    maxWidth="1000px"
    (close)="onAnalyticItemDialogClosed()"
  >
    <ng-template appXIModalContent>
      @if (showAnalyticItemDialog) {
        <app-analytic-type-info-dialog></app-analytic-type-info-dialog>
      }
    </ng-template>
  </app-lex-xi-modal>
}
@if (showEditConfigurationsModal) {
  <app-lex-xi-modal
    [isVisible]="showEditConfigurationsModal"
    maxWidth="720px"
    (close)="onEditConfigurationsModalClosed(null)"
    ><ng-template appXIModalContent>
      <app-edit-configurations-dialog
        [data]="editConfigurationsDialogData"
        (modalClosed)="onEditConfigurationsModalClosed($event)"
      ></app-edit-configurations-dialog></ng-template
  ></app-lex-xi-modal>
}
